/**
 * @ngdoc directive
 * @name abookApp.directive:dibsForm
 * @description
 */

export default function dibsLegacy() {
    return {
        template: require("./template.html"),
        scope: {
            bookingId: "<",
            amount: "<",
            bookingPeriods: "<",
        },

        controller: function (ENV, $scope, $location, paymentService) {
            $scope.debug = false;
            /* Nets EasyPay */
            var paymentNowEventListener = $scope.$on(
                "payment-now-broadcast",
                function () {
                    paymentService
                        .create($scope.bookingId)
                        .then((result) => {
                            window.location =
                                result.hostedPaymentPageUrl + "&language=da-DK";
                        })
                        .catch(function () {
                            alert(
                                "Du har været for længe om at gennemføre din booking. Prøv igen."
                            );
                            // Redirect to frontpage
                            $location.path("/");
                        });
                }
            );
            $scope.$on("$destroy", paymentNowEventListener);
        },
    };
}
